import { BsDatepickerConfig, BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { ErrorHandler, InjectionToken, Injector, LOCALE_ID, Provider } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { BreadcrumbService, BrowserNavigationService, CriticalStateService, HotkeysService, LanguageService, PageLoaderService, PageService, UserSessionService } from '../services';
import { getDatepickerConfig, getDaterangepickerConfig } from '../functions';
import { VersionInterceptor, ErrorInterceptor } from '../interceptors';
import { AppErrorHandler } from '../classes';

export const APP_HOME_URL = new InjectionToken<string>('APP_HOME_URL');

export function provideFoundationServices(): Provider[] {
	return [
		BreadcrumbService,
		BrowserNavigationService,
		CriticalStateService,
		HotkeysService,
		LanguageService,
		PageLoaderService,
		PageService,
		UserSessionService,
		{
			provide: LOCALE_ID,
			useValue: 'fr-FR'
		},
		{
			provide: BsDatepickerConfig,
			useFactory: getDatepickerConfig
		},
		{
			provide: BsDaterangepickerConfig,
			useFactory: getDaterangepickerConfig
		},
		{
			provide: ErrorHandler,
			useClass: AppErrorHandler
		},
		{ provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true, deps: [Injector] },
		{ provide: HTTP_INTERCEPTORS, useClass: VersionInterceptor, multi: true, deps: [Injector] },

	]
}
